import { webDownload } from "creso-core/hooks";
import { MarketingResource } from "creso-core/types";
import { DownloadIcon, FileIcon } from "lucide-react";
import { Button, cn } from "web-design-system";
import { Link } from "@tanstack/react-router";
import {
  formatResourceDate,
  getNewsletterPages,
  getResourceLink,
} from "creso-core/utils";

export function NewsletterRow({
  item,
  showBorder,
}: {
  item: MarketingResource;
  showBorder: boolean;
}) {
  const handleDownload = async (resource: MarketingResource) => {
    const url = getResourceLink(resource);

    if (!url) {
      return;
    }

    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const pdfBlob = await response.blob();
      await webDownload(pdfBlob, `${resource.title}.pdf`);
    } catch {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div
      className={cn(
        "flex items-center gap-10 py-6 w-full min-w-0",
        showBorder && "border-b border-border/50"
      )}
    >
      <Link
        to={getResourceLink(item)}
        target="_blank"
        className="no-underline! flex items-center gap-3 w-full min-w-0"
      >
        <div className="flex size-8 shrink-0 items-center justify-center rounded-md bg-tag-yellow/80 text-tag-yellow-foreground">
          <FileIcon className="size-5" />
        </div>
        <div className="text-sm line-clamp-2">{item.title}</div>
      </Link>
      <div className="text-sm shrink-0">{getNewsletterPages(item)}</div>
      <div className="text-sm shrink-0">
        {formatResourceDate(item.publish_date ?? "", "dd MMM")}
      </div>
      <Button
        variant="link"
        className="h-auto p-0 text-sm shrink-0 [&_svg]:size-5 cursor-pointer"
        onClick={() => handleDownload(item)}
      >
        <DownloadIcon className="size-5" />
      </Button>
    </div>
  );
}
